// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__usGci","active":"styles_active__yBMv_"};